module.exports = __webpack_public_path__ + "static/media/AppStoreBadge.2928664f.svg";